var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66602 24.4987V11.0862C4.66602 7.91064 7.24267 5.33398 10.4182 5.33398H13.7052",
    stroke: "#CBDB2A",
    strokeWidth: 1.13719,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.174 15.4316V20.2507C22.174 22.5906 20.2658 24.4987 17.926 24.4987H8.24609",
    stroke: "#CBDB2A",
    strokeWidth: 1.13719,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7935 17.8979C10.7935 17.8979 10.515 7.20132 22.5208 8.70553",
    stroke: "#CBDB2A",
    strokeWidth: 1.13719,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9004 4.66602L22.8698 8.63545L18.9004 12.4656",
    stroke: "#CBDB2A",
    strokeWidth: 1.13719,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportYellow);
export default __webpack_public_path__ + "static/media/exportYellow.b7fac083d9fed25a49baf11a22b95f01.svg";
export { ForwardRef as ReactComponent };